/* Keep wide editorial tables readable without widening the whole article. */
(() => {
  document.querySelectorAll('.article-template__content table').forEach((table, index) => {
    if (table.parentElement.classList.contains('dd-article-table-scroll')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'dd-article-table-scroll';
    table.before(wrapper);
    wrapper.append(table); // Move the original node; preserve table semantics and listeners.
    const update = () => {
      const overflowing = wrapper.scrollWidth > wrapper.clientWidth + 1;
      if (overflowing || document.activeElement === wrapper) {
        // A resize must not blur the active reader; retire its tab stop on exit.
        wrapper.tabIndex = overflowing ? 0 : -1;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || `Scrollable table ${index + 1}`);
      } else {
        wrapper.removeAttribute('tabindex');
        wrapper.removeAttribute('role');
        wrapper.removeAttribute('aria-label');
      }
    };
    wrapper.addEventListener('blur', update);
    update();
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(update);
      observer.observe(wrapper);
      observer.observe(table);
    } else {
      window.addEventListener('resize', update);
      window.addEventListener('load', update, { once: true });
    }
  });
})();
